(function(){
  var FREE=10000;
  function money(c){return '$'+(c/100).toFixed(2);}
  var nav=document.getElementById('nav');
  if(nav){window.addEventListener('scroll',function(){nav.classList.toggle('scrolled',window.scrollY>40);});}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  var tt;
  function toast(m){var t=document.getElementById('toast');if(!t)return;t.textContent=m;t.classList.add('show');clearTimeout(tt);tt=setTimeout(function(){t.classList.remove('show');},2600);}
  window.huskaToast=toast;
  var drawer=document.getElementById('cartDrawer'),overlay=document.getElementById('cartOverlay');
  function openCart(){if(!drawer)return;renderCart();drawer.classList.add('open');overlay.classList.add('open');}
  function closeCart(){if(!drawer)return;drawer.classList.remove('open');overlay.classList.remove('open');}
  document.querySelectorAll('[data-cart-open]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();openCart();});});
  document.querySelectorAll('[data-cart-close]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();closeCart();});});
  function setCount(n){var c=document.getElementById('cartCount');if(c)c.textContent=n;}
  function getCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});}
  function lineHTML(i){
    var vt=(i.variant_title&&i.variant_title!=='Default Title')?(' \u2014 '+i.variant_title):'';
    return '<div class="cart-item"><div class="ci-top"><span class="ci-name">'+i.product_title+vt+'</span><span class="ci-price">'+money(i.final_line_price)+'</span></div>'+
    '<div class="ci-bottom"><div class="ci-qty"><button type="button" data-key="'+i.key+'" data-d="-1">\u2212</button><span>'+i.quantity+'</span><button type="button" data-key="'+i.key+'" data-d="1">+</button></div>'+
    '<button class="ci-remove" type="button" data-key="'+i.key+'" data-d="0">Remove</button></div></div>';
  }
  function renderCart(){
    var body=document.getElementById('cartBody'),foot=document.getElementById('cartFoot');
    if(!body)return;
    return getCart().then(function(cart){
      setCount(cart.item_count);
      if(!cart.items.length){body.innerHTML='<div class="cart-empty"><p>Your cart is empty.</p><span>The Locked In travel light \u2014 for now.</span></div>';if(foot)foot.style.display='none';return;}
      if(foot)foot.style.display='block';
      body.innerHTML=cart.items.map(lineHTML).join('');
      var total=cart.total_price,left=FREE-total;
      var sub=document.getElementById('cartSubtotal');if(sub)sub.textContent=money(total);
      var ship=document.getElementById('cartShip');
      if(ship){if(left>0){ship.innerHTML='<div class="cart-ship">You\'re <b>'+money(left)+'</b> from free shipping</div><div class="cart-bar"><span style="width:'+Math.min(100,total/FREE*100)+'%"></span></div>';}else{ship.innerHTML='<div class="cart-ship gold">Free shipping unlocked</div>';}}
      body.querySelectorAll('[data-key]').forEach(function(btn){btn.addEventListener('click',function(){
        var key=btn.getAttribute('data-key'),d=parseInt(btn.getAttribute('data-d'),10);
        getCart().then(function(c){var it=null;c.items.forEach(function(x){if(x.key===key)it=x;});var q=(d===0)?0:Math.max(0,(it?it.quantity:0)+d);
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:q})}).then(function(){renderCart();});});
      });});
    });
  }
  var form=document.getElementById('product-form');
  if(form){
    var qInput=form.querySelector('[data-qty-input]'),qEl=document.getElementById('qtyVal');
    form.querySelectorAll('[data-qty]').forEach(function(b){b.addEventListener('click',function(){var q=parseInt(qInput.value,10)+parseInt(b.getAttribute('data-qty'),10);if(q<1)q=1;qInput.value=q;if(qEl)qEl.textContent=q;});});
    var dataEl=document.querySelector('[data-variants]');
    var variants=dataEl?JSON.parse(dataEl.textContent):[];
    var idInput=form.querySelector('[data-variant-id]');
    var priceEl=document.getElementById('pdpPrice'),atc=form.querySelector('[data-atc]');
    var selected={};
    function optsOf(v){return (v.options&&v.options.length)?v.options:[v.option1,v.option2,v.option3].filter(function(x){return x!==null&&x!==undefined;});}
    document.querySelectorAll('.pdp-swatches').forEach(function(group){
      var idx=group.getAttribute('data-option-index');
      var sel=group.querySelector('.pdp-sw.sel');if(sel)selected[idx]=sel.getAttribute('data-value');
      group.querySelectorAll('.pdp-sw').forEach(function(sw){sw.addEventListener('click',function(){
        group.querySelectorAll('.pdp-sw').forEach(function(s){s.classList.remove('sel');});
        sw.classList.add('sel');selected[idx]=sw.getAttribute('data-value');update();
      });});
    });
    function currentVariant(){return variants.find(function(v){var o=optsOf(v);return Object.keys(selected).every(function(i){return String(o[i])===String(selected[i]);});});}
    function update(){
      document.querySelectorAll('.pdp-swatches').forEach(function(g){var gi=g.getAttribute('data-option-index');var lbl=g.previousElementSibling&&g.previousElementSibling.querySelector('[data-selname]');if(lbl&&selected[gi])lbl.textContent=selected[gi];});
      var v=currentVariant();
      if(!v){if(atc){atc.disabled=true;atc.textContent='Unavailable';}return;}
      idInput.value=v.id;var m=money(v.price);if(priceEl)priceEl.textContent=m;
      if(v.available){atc.disabled=false;atc.innerHTML='Add To Cart \u2014 <span data-atc-price>'+m+'</span>';}
      else{atc.disabled=true;atc.textContent='Sold Out';}
    }
    update();
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var payload={items:[{id:parseInt(idInput.value,10),quantity:parseInt(qInput.value,10)}]};
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)}).then(function(r){
        if(r.ok){toast('Added to cart');openCart();}else{r.json().then(function(err){toast((err&&err.description)||'Could not add');});}
      });
    });
  }
  window.HuskaCart={open:openCart,close:closeCart,render:renderCart};
})();
